import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { format } from "date-fns";
import TimePicker from 'react-time-picker';

import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "react-datepicker/dist/react-datepicker.css";
import { Country, State, City } from "country-state-city";
import { useParams } from "react-router-dom";
import AsyncSelect from "react-select/async";

import { Modal } from "./common/modal/Modal";
import { HeaderModal } from "./common/modal/Header";
import { Body } from "./common/modal/Body";
import Tabs from "./common/Tabs";

import modalCloseIcon from "../assets/images/modal-close-icon.svg";
import starIcon from "../assets/images/star-grey-icons.svg";
import objectiveIcon from "../assets/images/objective-icon.svg";
import calenderIcon from "../assets/images/callender-icon.svg";
import allImgPaths from "assets/images";

import { editEventsData, getEventsData, getLocation } from "../services/board";

import {
	RANGE,
	getAbrivationTimeZone,
	getAllCities,
	getAllCountryAbbreviation,
	timeZoneWithStates
} from "../utils/constant";
import { InputTextField } from "./InputField";
import { t } from "i18next";
import useAppState from "../context/useAppState";
import { cloneDeep, debounce, isEqual, isNaN } from "lodash";
import { getMaxValueForRange, getMinValueForRange, getRangeStep } from "utils/fete";
import { formatNumber } from "utils/function";

const FeteEditModal = (props: any) => {
	const [formData, setFormData] = useState<any>({
		name: "",
		objective: "",
		date: { startDate: new Date(), endDate: null },
		type: "",
		format: "",
		location: [],
		attendees: { min: 0, max: 100 },
		budget: { min: 0, max: 100 },
		end_date: null,
		start_date: new Date(),
		timeZone: "",
		times: []
	});
	const actualFormData = useRef<any>({});
	const navigate = useNavigate();
	const [activeTabId, setActiveTabId] = useState(null);
	const [attendeesRange, setAttendeesRange] = useState([0, 0]);
	const [dynamicAttendeesRange, setDynamicAttendeesRange] = useState([0, 5000]);
	const [budgetRange, setBudgetRange] = useState<string[]>(["100", "50000"]);
	const [dynamicBudgetRange, setDynamicBudgetRange] = useState([100, 50000]);
	const { setState: setEventDataState, updateEventCallApiFlag, unsavedChanges } = useAppState("eventData");
	const [page, setPage] = useState(1);
	const [isAccordionActive, setIsAccordionActive] = useState<number | null>(0);
	const [clockValue, onChange] = useState<any>('09:00');
	const [events, setEvents] = useState<{ startDate: number | null, startTime: string | null, endTime: string | null }[]>([{ startDate: null, startTime: null, endTime: null }]);
	const [hasBudgetValues, setHasBudgetValues] = useState({ min: false, max: false });
	const [error, setError] = useState<any>({ nameValidation: "", feteTypeValidation: "", budgetValidation: "" });
	const [dateRange, setDateRange] = useState<any>([null, null]);
	const [dropdownValue, setDropdownValue] = useState(null);
	const [timeZoneDropdownValue, setTimeZoneDropdownValue] = useState(null);
	const params: any = useParams();
	const [startDate, endDate]: any = dateRange;
	const [startCustomDate, setStartCustomDate] = useState<any>(new Date());
	const [saveBtnDisabled, setSaveBtnDisabled] = useState(true)
	const [totalBudgetAllocation, setTotalBudgetAllocation] = useState(0)
	const [budgetAllocationError, setBudgetAllocationError] = useState(false);

	// const countryCode = "US";
	// const country: any = Country.getCountryByCode(countryCode);
	// const cities: any = City.getCitiesOfCountry(country.isoCode);

	const allCountries: any = getAllCountryAbbreviation();

	const cities = getAllCities()

	const options = cities.map((item: any) => ({
		label: `${item.name} , ${item.stateCode} , ${item.countryCode}`,
		value: item.name,
	}));


	const countriesAbbreviationRecord = getAbrivationTimeZone(
		allCountries.timezones
	);

	const timeZoneOptions = countriesAbbreviationRecord.map((item: any) => ({
		label: item.tzName,
		value: item.zoneName,
	}));

	const customSelectStyle = {
		singleValue: (styles: any) => ({
			...styles,
			color: "#344054",
		}),
		valueContainer: (styles: any) => ({
			...styles,
			backgroundColor: "#fff",
			padding: "0px 0px 0px 5px",
			fontSize: "14px",
			cursor: "pointer",
		}),
		control: (styles: any) => ({
			...styles,
			backgroundColor: "#fff",
			padding: "4px 12px",
			borderRadius: "8px",
			cursor: "pointer",
			boxShadow: "0",
			"&:hover": {
				border: "1px solid #D0D5DD",
			},
		}),
		indicatorContainer: (styles: any) => ({
			...styles,
			padding: "0px 0px",
		}),
		indicatorSeparator: (styles: any) => ({ ...styles, display: "none" }),
		dropdownIndicator: (styles: any) => ({
			...styles,
			color: "#85888E",
			cursor: "pointer",
			"&:hover": { color: "#85888E" },
			paddingRight: "0px",
		}),
		menu: (styles: any) => ({
			...styles,
			left: "0",
			boxShadow:
				"0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
			backgroundColor: "#fff",
			borderRadius: "12px",
			margin: "0px",
			overflow: "hidden",
		}),
		menuList: (styles: any) => ({
			...styles,
			backgroundColor: "#fff",
			maxHeight: "192px",
			padding: "4px 4px",
		}),
		option: (styles: any, { isFocused }: any) => ({
			...styles,
			cursor: "pointer",
			fontSize: "15px",
			fontWeight: "500",
			color: "#344054",
			padding: "6px 6px 6px 6px",
			borderRadius: "10px",
			marginBottom: "4px",
			backgroundColor: isFocused ? "#fff" : "#fff",
			"&:active": { color: "#1e0af5", backgroundColor: '#fff' },
			"&:hover": { color: "#1e0af5" }
		}),
		placeholder: (styles: any) => ({
			...styles,
			fontWeight: "500",
			fontSize: "16px",
		}),
	};

	const updateHasBudgetValues = ({ min, max }: any) => {
		setHasBudgetValues({
			min: min > 0,
			max: max > 0
		});
	};

	const stateTimezones: any[] = timeZoneWithStates;

	useEffect(() => {
		const fetchData = async () => {
			try {
				const { data } = await getEventsData(params.id);
				const {
					name,
					objective,
					type,
					format,
					locations,
					start_date,
					end_date,
					attendees,
					budget,
					time_zone,
					times
				} = data;

				const formDataObj = {
					name: name,
					objective: objective,
					type: type,
					format: format,
					location: locations,
					attendees: attendees,
					budget: budget,
					start_date: parseInt(start_date),
					end_date: parseInt(end_date),
					timeZone: time_zone,
					times: times
				}

				if (data?.totalBudgetAllocation) {
					setTotalBudgetAllocation(data.totalBudgetAllocation)
				}

				setFormData(formDataObj);
				actualFormData.current = cloneDeep(formDataObj)

				setDateRange([new Date(start_date), new Date(end_date)]);
				setEvents(times)

				setActiveTabId(format);
				let selectedOption = locations.map((location: any) =>
					options.find((option: any) => option.label?.replace(/\s*,\s*/g, ', ').toLowerCase().startsWith(location.trim().toLowerCase()))
				).filter(Boolean);

				if (!selectedOption?.length) {
					selectedOption = locations.map((location: any) =>
						options.find((option: any) => option.label?.toLowerCase().startsWith(location?.split(',')?.[0].trim()?.toLowerCase()))
					);
				}

				// const selectedTimeZoneOption: any = timeZoneOptions.find(
				// 	(option: any) => option.label === time_zone
				// );

				const cityISOCode = selectedOption?.length ? selectedOption[0].label.match(/\b[A-Z]{2}\b/)[0] : null;
				const cityTimeZone = stateTimezones.find(st => st.states.includes(cityISOCode))?.timezone || null;
				const selectedTimeZone = countriesAbbreviationRecord.find(ca => ca.tzName === cityTimeZone)

				let selectedTimeZoneValue: any = null
				if (selectedTimeZone) {
					selectedTimeZoneValue = {
						label: selectedTimeZone.tzName, value: selectedTimeZone.zoneName
					}
				}
				setDropdownValue(selectedOption);
				setTimeZoneDropdownValue(time_zone);
				setAttendeesRange([attendees.min || 0, attendees.max || 0]);
				setDynamicAttendeesRange([getMinValueForRange(attendees.min), getMaxValueForRange(attendees.max)])
				// setBudgetRange([budget.min, budget.max]);
				setBudgetRangeValues(budget.min || 0, budget.max || 0)
				setDynamicBudgetRange([getMinValueForRange(budget.min), getMaxValueForRange(budget.max)])
				setTimeZoneDropdownValue(selectedTimeZoneValue);
				updateHasBudgetValues(budget);
				// addDefaultEvents(times, start_date, end_date)

			} catch (error: any) {
				if (error.response?.data.message === "You are not a part of this event") {
					navigate('/');
				}
				console.log('error', error)
			}

		};
		fetchData();
	}, []);

	useEffect(() => {
		areArraysEqual(formData, actualFormData.current)
	}, [formData])

	useEffect(() => {
		const handleBeforeUnload = (e: any) => {
			if (unsavedChanges) {
				e.preventDefault();
				e.returnValue = ''; // Modern browsers require this to show the alert
				return '';
			}
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [unsavedChanges])

	const areArraysEqual = (original: any, cloned: any) => {
		const isSame = isEqual(original, cloned);
		setSaveBtnDisabled(isSame)
		setEventDataState({ unsavedChanges: !isSame })
	};

	const tabs = [
		{ id: 1, label: "In-Person" },
		{ id: 2, label: "Hybrid" },
		{ id: 3, label: "Online" },
	];

	const setBudgetRangeValues = (min: number, max: number) => {
		const updatedMin: any = min ? min.toLocaleString() : 0
		const updatedMax: any = max ? max.toLocaleString() : 0
		setBudgetRange([updatedMin, updatedMax])
	}

	const handleNameChange = (event: any) => {
		if (event.target?.value?.trim() !== "") setError({ nameValidation: "" });

		setFormData({
			...formData,
			[event.target.name]: event.target.value,
		});
	};

	const handleTypeChange = (event: any) => {
		if (event.target?.value?.trim() !== "") setError({ feteTypeValidation: "" });

		setFormData({
			...formData,
			[event.target.name]: event.target.value,
		});
	};

	const handleObjectiveChange = (event: any) => {
		setFormData({
			...formData,
			[event.target.name]: event.target.value,
		});
		if (event.target.name === "objective") {
			let getTextArea = document.getElementById("textAreaRef");
			if (getTextArea) {
				if (event.target.value.length === 0) {
					event.target.style.height = "24px";
				} else {
					event.target.style.height = "auto";
					event.target.style.height = event.target.scrollHeight + "px";
				}
			}
		}
	};

	const handleDateChange = (update: any) => {
		let data1: any, data2: any;
		setDateRange(update);
		if (update[1]) {
			data1 = format(update[0], "T");
			data2 = format(update[1], "T");
		}

		setFormData({
			...formData,
			start_date: parseInt(data1),
			end_date: parseInt(data2),
		});
	};

	const handleTabChange = (tabId: any, tabLabel: any) => {
		setActiveTabId(tabId);

		setFormData({
			...formData,
			format: tabId,
		});
	};

	const submitForm = (event: any) => {
		event.preventDefault();

		const newErrors = {
			nameValidation: '',
			feteTypeValidation: '',
			budgetValidation: ''
		}
		if (formData.name?.trim() === "") {
			newErrors.nameValidation = "Please enter a name for this fete"
		}
		if (formData.type?.trim() === "") {
			newErrors.feteTypeValidation = "Please enter a type for this fete"
		}
		if (newErrors.nameValidation === '' && newErrors.feteTypeValidation === '') {
			postData();
		} else {
			setError({ ...newErrors })
		}
	};

	const handleChange = (selectedOption: any) => {
		const cityISOCode = selectedOption?.length ? selectedOption[0].label.match(/\b[A-Z]{2}\b/)[0] : null;
		const cityTimeZone = stateTimezones.find(st => st.states.includes(cityISOCode))?.timezone || null;
		const selectedTimeZone = countriesAbbreviationRecord.find(ca => ca.tzName === cityTimeZone)

		setDropdownValue(selectedOption);
		setFormData({
			...formData,
			// location: selectedOption.map((option: any) => option.value),
			location: selectedOption.map((option: any) => option.label),
		});

		if (selectedTimeZone) {
			const selectedTimeZoneValue: any = {
				label: selectedTimeZone.tzName, value: selectedTimeZone.zoneName
			}
			setTimeZoneDropdownValue(selectedTimeZoneValue);
			setFormData({
				...formData,
				// location: selectedOption.map((option: any) => option.value),
				location: selectedOption.map((option: any) => option.label),
				timeZone: selectedTimeZoneValue.label,
			});
		}
	};

	const handleTimeZoneChange = (selectedOption: any) => {
		setTimeZoneDropdownValue(selectedOption);
		setFormData({
			...formData,
			timeZone: selectedOption.label,
		});
	};

	const postData = async () => {
		try {
			// Manage dates from times array 
			const updatedEvents = events?.length ? events.filter(ev => ev.startDate !== null).sort((a: any, b: any) => a.startDate - b.startDate) : []
			const eventLength = updatedEvents?.length || 0;
			const startDate = eventLength ? updatedEvents[0].startDate : null;
			const endDate = eventLength ? (eventLength > 1 ? updatedEvents[eventLength - 1].startDate : updatedEvents[0].startDate) : null;

			// Manage budget conversions
			const budget: any = formData.budget;
			budget['min'] = budgetRange?.[0] ? parseInt(budgetRange[0].replace(/,/g, '')) : 0
			budget['max'] = budgetRange?.[1] ? parseInt(budgetRange[1].replace(/,/g, '') || '0') : 0;
			formData.budget = budget

			const payload = {
				name: formData.name,
				objective: formData.objective,
				type: formData.type,
				format: parseInt(formData.format),
				locations: formData.location,
				// start_date: formData?.start_date,
				// end_date: formData?.end_date,
				start_date: startDate,
				end_date: endDate,
				time_zone: formData.timeZone,
				attendees: formData.attendees,
				budget: formData.budget,
				times: formData.times || events
				// times: events
			};

			if (
				typeof payload?.budget?.min === "number" &&
				typeof payload?.budget?.max === "number" &&
				payload.budget.min > payload.budget.max
			) {
				setError({ ...error, budgetValidation: 'Invalid budget range' })
				return;
			}

			const { message }: any = await editEventsData(params.id, payload);
			updateEventCallApiFlag(true);

			setEventDataState({ unsavedChanges: false })
			props.setOpenEditModal(false);
			setIsAccordionActive(null);

		} catch (error) {
			console.log(error);
		}
	};

	const handleMinChange = (e: any) => {
		const value = e.target.value
		const [, max] = attendeesRange;
		setAttendeesRange([value, max]);
		setDynamicAttendeesRange([getMinValueForRange(value), getMaxValueForRange(max)])
		setFormData({
			...formData,
			attendees: { ...formData.attendees, min: value > 0 ? +value : null },
		});
	};

	const handleMaxChange = (e: any) => {
		const value = parseInt(e.target.value);
		const [min] = attendeesRange;
		setDynamicAttendeesRange([getMinValueForRange(min), getMaxValueForRange(value)])
		setAttendeesRange([min, value]);
		setFormData({
			...formData,
			attendees: { ...formData.attendees, max: value > 0 ? +value : null },
		});
	};

	const handleMinBudgetChange = (e: any) => {
		const value = e.target.value;
		const [, max] = budgetRange;

		const parsedValue = parseInt(value.replace(/,/g, ''));
		let formattedValue = parsedValue.toLocaleString();

		if (value === "") {
			formattedValue = "0";
		}

		if (typeof formData?.budget?.max == 'number' && (parsedValue <= formData?.budget?.max)) {
			setError({ ...error, budgetValidation: '' })
		}

		setBudgetRange([formattedValue, max]);
		setDynamicBudgetRange([getMinValueForRange(value), getMaxValueForRange(max)])
		setFormData({
			...formData,
			budget: { ...formData.budget, min: value > 0 ? +value : 0 },
		});
		updateHasBudgetValues({ ...hasBudgetValues, min: parseInt(value) })
	};

	const handleMaxBudgetChange = (e: any) => {
		const value = e.target.value;
		const [min] = budgetRange;

		const parsedValue = parseInt(value.replace(/,/g, ''));
		let formattedValue = parsedValue.toLocaleString();

		if (value === "") {
			formattedValue = "0";
		}

		if (typeof formData?.budget?.min == 'number' && (parsedValue >= formData?.budget?.min)) {
			setError({ ...error, budgetValidation: '' })
		}

		setBudgetAllocationError(totalBudgetAllocation > parsedValue ? true : false)

		setBudgetRange([min, formattedValue]);
		setDynamicBudgetRange([getMinValueForRange(min), getMaxValueForRange(value)])
		setFormData({
			...formData,
			budget: { ...formData.budget, max: value > 0 ? +value : 0 },
		});
		updateHasBudgetValues({ ...hasBudgetValues, max: parseInt(value) })
	};

	const debouncedLoadOptions = React.useRef(debounce(async (inputValue: any, callback: any) => {
		try {
			const { data }: any = await getLocation({
				search: inputValue,
				page_number: page
			});
			callback(data); // Pass the fetched options to the callback function
		} catch (error) {
			console.error('Error fetching options:', error);
			throw error;
		}
	}, 200)); // 300 milliseconds debounce timeout

	const loadOptions = (inputValue: any, callback: any) => {
		// Call the debounced version of loadOptions function
		debouncedLoadOptions.current(inputValue, callback);
	};

	// const addDefaultEvents = (times: any[], startDate?: any, endDate?: any) => {
	// 	if (times?.length) {
	// 		setEvents([...times])
	// 	} else {
	// 		// Set event array for events not having them and then save
	// 		let eventData: any = []
	// 		if (startDate === endDate) {
	// 			eventData.push({ startDate, startTime: '10:00', endTime: '10:00' })
	// 		} else {
	// 			const defaultStartDate = Math.min(startDate, endDate)
	// 			const defaultEndDate = Math.max(startDate, endDate);

	// 			const date1: any = new Date(defaultStartDate);
	// 			const date2: any = new Date(defaultEndDate);

	// 			const differenceInMs: any = date2 - date1;
	// 			const totalDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) + 1;

	// 			for (let i = 0; i < totalDays; i++) {
	// 				const currentDate = new Date(startDate);
	// 				currentDate.setDate(currentDate.getDate() + i);
	// 				eventData.push({ startDate: currentDate.getTime(), startTime: '10:00', endTime: '10:00' })
	// 			}

	// 		}
	// 		setEvents([...eventData])
	// 	}
	// }

	const handleAddEvent = () => {
		// const newEvent = { startDate: null, startTime: null, endTime: null };

		let startDate = Date.now();
		if (events?.length) {
			const dt = new Date(events[events.length - 1].startDate as number);
			dt.setDate(dt.getDate() + 1);

			const updDate = new Date(dt)
			updDate.setHours(0, 0, 0, 0);
			startDate = updDate.getTime()
		}

		const newEvent = { startDate: startDate, startTime: '09:00', endTime: '16:00' };
		const allEvents = [...events, newEvent]
		setFormData({
			...formData,
			times: allEvents
		})
		setEvents([...events, newEvent]);
	};

	const handleDeleteEvent = (index: number) => {
		const updatedEvents = events.filter((_, i) => i !== index);
		setEvents(updatedEvents);
		setFormData({
			...formData,
			times: updatedEvents
		})
	};

	const setCustomTime = (value: any, index: any, type: string) => {
		if (type === 'startDate') {
			const updDate = new Date(value)
			updDate.setHours(0, 0, 0, 0);

			events[index].startDate = updDate.getTime();
		}
		if (type === 'startTime') {
			events[index].startTime = value;
		}
		if (type === 'endTime') {
			events[index].endTime = value;
		}

		setFormData({
			...formData,
			times: [...events]
		})
		setEvents([...events])
	}

	const closeModal = (e: any) => {
		if (unsavedChanges) {
			const message = `You’ve unsaved changes. Are you sure you want to leave?`
			const confirmLeave = window.confirm(message);
			if (!confirmLeave) {
				e.preventDefault()
				return
			} else {
				setEventDataState({ unsavedChanges: false })
				props.setOpenEditModal(false);
				setIsAccordionActive(null);
			}
		} else {
			props.setOpenEditModal(false);
			setIsAccordionActive(null);
		}
	}

	return (
		<div>
			<Modal className={"modal-wrapper max-w-[960px] !bg-[#F9F9F9]"} isShow={props.isShow}>
				<HeaderModal
					title=""
					isShowHeader={true}
					className="modal-header pt-6 px-6 pb-5"
				>
					<div className="flex items-center justify-between">
						<h2 className="text-lg text-[#101828] font-interSemiBold leading-none">
							Edit Fete
						</h2>
					</div>

				</HeaderModal>

				<Body title="" isShowBody={true} className="modal-body">
					<form onSubmit={submitForm}>
						<div className="max-h-[calc(100vh_-_220px)] overflow-y-auto">
							{/* Event Essentials */}
							<div className={`${isAccordionActive === 0 ? "" : "accordion-hide"} px-5 py-5 border border-[#EEE] rounded-2xl bg-white mx-6 mb-6`}>
								<div onClick={() => { setIsAccordionActive(isAccordionActive === 0 ? null : 0) }} className="accordion-heading flex items-center justify-between mb-6 cursor-pointer">
									<h2 className="text-base text-[#101828] font-interSemiBold on-hover-blue">Fete Essentials</h2>
									<img className="accordion-arrow cursor-pointer hover:bg-[#f2f4f7] rounded " src={allImgPaths.downArrowIcon4} alt="" />
								</div>
								<div className="accordion-content">
									<div className="flex gap-x-3 mb-4">
										{ /* Fete Type */}
										<div className="w-1/2">
											<p className="text-[#344054] text-sm font-interMedium pb-1.5">
												Fete Type
												<span className="text-[#D92D20]">*</span>
											</p>
											<div className="relative ">
												<div className="">
													<InputTextField
														className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full fete-type-icon !pl-10"
														name={"type"}
														placeholder={"Please enter fete type"}
														onChange={handleTypeChange}
														value={formData.type}
														err={error.feteTypeValidation}
														errorButton={error.feteTypeValidation && true}
													/>
												</div>
												<p className="text-[#475467] text-sm pt-[3px]">Select or type your own (max. 20 chars)   </p>
											</div>
										</div>

										{/* Event Format */}
										<div className="w-1/2">
											<p className="text-[#344054] text-sm font-interMedium pb-1.5">
												Fete Format
												<span className="text-[#D92D20]">*</span>
											</p>
											<div className="relative w-full">
												<Tabs
													tabs={tabs}
													onChange={handleTabChange}
													defaultTab={activeTabId}
												/>
											</div>
										</div>
									</div>

									{/* Title */}
									<div className="mb-6">
										<p className="text-[#344054] text-sm font-interMedium pb-1.5">
											Fete Title
											<span className="text-[#D92D20]">*</span>
										</p>
										<div className="relative ">
											<div className="">
												<InputTextField
													className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full fete-title-icon !pl-10"
													name={"name"}
													placeholder={"Please enter fete title"}
													onChange={handleNameChange}
													value={formData.name}
													err={error.nameValidation}
													errorButton={error.nameValidation && true}
												/>
											</div>
										</div>
									</div>

									{/* Fete Objective */}
									<div className="">
										<p className="text-[#344054] text-sm font-interMedium pb-1.5">
											Fete Objective
										</p>
										<div className="relative">
											<div className="border border-[#D0D5DD] hover:border-[#1E0AF5] focus-within:border-[#1E0AF5] rounded-lg flex items-start gap-x-2 py-2 px-3">
												<img
													className="w-[22px] h-[22px] flex-shrink-0 mt-0.5"
													src={objectiveIcon}
													alt="star icon"
												/>
												<textarea
													id="textAreaRef"
													name="objective"
													maxLength={200}
													value={formData.objective}
													onChange={handleObjectiveChange}
													className="placeholder:text-[#344054] placeholder:text-base text-base text-[#344054] w-full h-[24px]"
													placeholder="Enter goal of the fete"
													style={{
														width: "100%",
														boxSizing: "border-box",
														overflow: "hidden",
													}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>

							{/* When And Where */}
							<div className={`${isAccordionActive === 1 ? "" : "accordion-hide"} px-5 py-5 border border-[#EEE] rounded-2xl bg-white mx-6 mb-6`}>
								<div onClick={() => { setIsAccordionActive(isAccordionActive === 1 ? null : 1) }} className="accordion-heading flex items-center justify-between mb-6 cursor-pointer">
									<h2 className="text-base text-[#101828] font-interSemiBold on-hover-blue">When & Where</h2>
									<img className="accordion-arrow cursor-pointer hover:bg-[#f2f4f7] rounded " src={allImgPaths.downArrowIcon4} alt="" />
								</div>
								<div className="accordion-content">
									<div className="flex gap-x-3 mb-4">
										{/* Location */}
										<div className="w-1/2">
											<p className="text-[#344054] text-sm font-interMedium pb-1.5">
												Where do you want to host the event?
											</p>
											<div className="relative w-full">
												<AsyncSelect
													value={dropdownValue}
													onChange={handleChange}
													loadOptions={loadOptions} // Assign the loadOptions function for asynchronous data fetching
													isSearchable={true}
													placeholder=""
													isMulti
													className="multi-select-wrapper location location-icon placeholder:text-[#344054] placeholder:text-base text-base text-[#344054]"
													classNamePrefix="select"
													styles={customSelectStyle} // Pass custom select styles if needed
													components={{
														IndicatorSeparator: () => null,
													}}
													getOptionLabel={(option: any) => option.label}
													getOptionValue={(option: any) => option.value}
													pageSize={10}
													defaultOptions={true}
												/>
											</div>
											<p className="text-[14px] text-[#667085] pt-0.5 font-interMedium">
												<span className="text-[14px] text-[#667085] font-semibold">Multiple locations?</span>  Plan separate events for optimal experience.
											</p>
										</div>

										{/* Timezone */}
										<div className="w-1/2">
											<p className="text-[#344054] text-sm font-interMedium pb-1.5">
												Timezone
											</p>
											<div className="relative w-full">
												<Select
													value={timeZoneDropdownValue}
													onChange={handleTimeZoneChange}
													options={timeZoneOptions}
													isSearchable={true}
													placeholder="Select"
													className="multi-select-wrapper timezone-icon placeholder:text-[#344054] placeholder:text-base text-base text-[#344054]  disable-hover-on-focus"
													classNamePrefix="select"
													styles={customSelectStyle}
												// menuIsOpen={true}
												/>
											</div>
										</div>
									</div>

									{/* Date */}

									<div className="">
										<div className="">
											<div className="flex items-center gap-x-3 w-full">
												<p className="text-[#344054] text-sm font-interMedium pb-1.5 pl-1 w-[35%]">
													{/* When is fete planned? */}
													Date
												</p>
												<p className="text-[#344054] text-sm font-interMedium pb-1.5 pl-1 w-[32.5%]">
													{/* When is fete planned? */}
													Start Time
												</p>
												<p className="text-[#344054] text-sm font-interMedium pb-1.5 pl-1 w-[32.5%]">
													{/* When is fete planned? */}
													End Time
												</p>
												<div className="">
													<img className="select-none pointer-events-none opacity-0" src={allImgPaths.plusIcon5} alt="" />
												</div>
											</div>

											<div className="flex items-center gap-x-2 w-full">
												<div className="w-full">
													{/* This below div shd repeat */}
													{events.map((event: any, index: number) => (
														<div className="flex items-center gap-x-3 w-full mb-3 last:mb-0" key={index}>
															{/* Date */}
															<div className="w-[35%]">
																<div className="relative">
																	<div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
																		<img
																			className="w-[22px] h-[22px] flex-shrink-0 "
																			src={calenderIcon}
																			alt="star icon"
																		/>
																		<div className="custom-datepicker width-adjust w-full">

																			<DatePicker
																				className="custom-datepicker-input placeholder:text-[#667085] placeholder:text-base text-base text-[#344054] w-full caret-transparent"
																				// selected={startCustomDate}
																				// onChange={(date) => setStartCustomDate(date)}
																				selected={event?.startDate || startCustomDate}
																				onChange={(date) => setCustomTime(date, index, 'startDate')}
																			/>
																		</div>
																	</div>
																</div>
															</div>

															{/* Start Time */}
															<div className="w-[32.5%]">

																<div className="relative">
																	<div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
																		<img
																			className="w-[22px] h-[22px] flex-shrink-0 "
																			src={allImgPaths.clockIcon}
																			alt="star icon"
																		/>
																		<div className="custom-timepicker w-full">
																			<TimePicker
																				onChange={(time) => setCustomTime(time, index, 'startTime')}
																				value={event?.startTime || clockValue}
																				clockIcon={null}
																				clearIcon={null}
																				className={'hover:border-[#1e0af5]'}
																			/>


																		</div>
																	</div>
																</div>
															</div>

															{/* End Time */}
															<div className="w-[32.5%]">
																<div className="relative">
																	<div className="border border-[#D0D5DD] rounded-lg flex items-center gap-x-2 py-2 px-3 hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
																		<img
																			className="w-[22px] h-[22px] flex-shrink-0 "
																			src={allImgPaths.clockIcon}
																			alt="star icon"
																		/>
																		<div className="custom-timepicker w-full">
																			<TimePicker
																				// onChange={onChange}
																				onChange={(time) => setCustomTime(time, index, 'endTime')}
																				value={event?.endTime || clockValue}
																				clockIcon={null}
																				clearIcon={null}
																			/>
																		</div>
																	</div>
																</div>
															</div>
															{index !== 0 ? (
																<img onClick={() => handleDeleteEvent(index)} className="cursor-pointer w-7 hover:bg-[#FEE4E2] rounded p-0.5" src={allImgPaths.deleteIcon2} alt="" />

															) :
																<img onClick={handleAddEvent} className="cursor-pointer hover:bg-[#f2f4f7] rounded p-0.5" src={allImgPaths.plusIcon5} alt="" />
															}
														</div>
													))}
												</div>
											</div>
										</div>
									</div>

								</div>
							</div>

							{/* Resources & Audience */}
							<div className={`${isAccordionActive === 2 ? "" : "accordion-hide"} px-5 py-5 border border-[#EEE] rounded-2xl bg-white mx-6 mb-6`}>
								<div onClick={() => { setIsAccordionActive(isAccordionActive === 2 ? null : 2) }} className="accordion-heading flex items-center justify-between mb-6 cursor-pointer">
									<h2 className="text-base text-[#101828] font-interSemiBold on-hover-blue">Resources & Audience</h2>
									<img className="accordion-arrow cursor-pointer hover:bg-[#f2f4f7] rounded " src={allImgPaths.downArrowIcon4} alt="" />
								</div>
								<div className="accordion-content">
									<div>
										{/* People */}
										<div className="mb-6">
											<p className="text-[#344054] text-sm font-interMedium pb-2.5">
												How many people are you expecting ?
											</p>

											<div className="flex items-center gap-x-3">
												<div className="border border-[#D0D5DD] rounded-lg hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
													<input
														type="number"
														placeholder="Enter min"
														className="rounded-lg py-2 px-3 w-[195px]"
														min={0}
														value={attendeesRange[0]}
														onChange={handleMinChange}
													/>

												</div>
												<span>-</span>
												<div className="border border-[#D0D5DD] rounded-lg hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
													<input
														type="number"
														className="rounded-lg py-2 px-3 w-[195px]"
														min={0}
														value={attendeesRange[1]}
														placeholder="Enter max"
														onChange={handleMaxChange}
													/>
												</div>
											</div>
										</div>

										{/* Budget */}
										<div className="">
											<p className="text-[#344054] text-sm font-interMedium pb-2.5">
												What is your budget like?{" "}
											</p>

											<div className="flex items-center gap-x-3">

												<div className="border border-[#D0D5DD] rounded-lg flex items-center hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
													<span>
														<img src={allImgPaths.dollorIcon} alt="$" className="pl-2" />
													</span>
													<input
														type="text"
														placeholder="Enter min"
														className="rounded-lg py-2 pr-3 pl-2 w-[195px]"
														value={budgetRange[0]}
														min={0}
														onChange={handleMinBudgetChange}
													/>
												</div>
												<span>-</span>

												<div className="border border-[#D0D5DD] rounded-lg flex items-center hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
													<span>
														<img src={allImgPaths.dollorIcon} alt="$" className="pl-2" />
													</span>
													<input
														type="text"
														className="rounded-lg py-2 pr-3 pl-2 w-[195px]"
														value={budgetRange[1]}
														min={0}
														placeholder="Enter max"
														onChange={handleMaxBudgetChange}
													/>
												</div>
											</div>
											{
												error?.budgetValidation &&
												<p className="mt-2 text-[#D92D20] text-sm pl-px">
													{error.budgetValidation}
												</p>
											}
											{
												budgetAllocationError &&
												<>
													<div className="flex items-center gap-x-2 mt-4">
														<img className="" src={allImgPaths.warningToastIcon} alt="" />

														<div className="">
															<p className="text-[#475467] text-sm">
																<span className="text-[#344054] font-interSemiBold text-sm">Just to let you know this might be a problem. </span>
																Contracts were signed under earlier pricing conditions. Reducing the budget may have an effect
															</p>
														</div>
													</div>
												</>
											}
										</div>
									</div>
								</div>
							</div>

						</div>
						{/* save Button */}
						<div className="flex items-center gap-x-3 justify-end py-4 px-6 border-t border-[#EAECF0]">
							<button
								onClick={closeModal}
								// onClick={() => {
								// 	props.setOpenEditModal(false);
								// 	setIsAccordionActive(null);
								// }}
								className="text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-14 !text-base hover:bg-[#f2f4f7]">
								Cancel
							</button>
							<button
								type="submit"
								className={`!text-base text-white bg-[#1E0AF5] font-interMedium rounded-lg px-16 py-2.5 hover:bg-[#120693] ${saveBtnDisabled ? 'button-disabled' : ''}`}
								disabled={saveBtnDisabled}
							>
								Save
							</button>
						</div>
					</form>
				</Body>
			</Modal>
		</div>
	);
};

export default FeteEditModal;
